module.exports = __webpack_public_path__ + "img/logo_header_white.082c98aa.png";